const CheckBox = ({
  viewBox = "0 0 24 24",
  size = 24,
  color = "#333",
  ...props
}) => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    p-id="30808"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M199.0656 936.61184c-61.88032 0-112.22528-50.36032-112.22528-112.26112V198.67648c0-61.88032 50.34496-112.22528 112.22528-112.22528h683.92448a42.12736 42.12736 0 0 1 37.72416 23.14752 42.1632 42.1632 0 0 1-3.54304 44.12416L542.21824 667.3408a42.47552 42.47552 0 0 1-34.176 17.36192 42.4704 42.4704 0 0 1-26.72128-9.4976L279.56736 510.89408c-18.08896-14.73536-20.82304-41.44128-6.08768-59.53536a42.17344 42.17344 0 0 1 32.83456-15.59552c9.69216 0 19.17952 3.37408 26.70592 9.50272l167.15264 136.13056 299.53024-410.30144H199.0656a27.61728 27.61728 0 0 0-27.58656 27.58656v625.67936a27.63264 27.63264 0 0 0 27.58656 27.61728h625.65888a27.648 27.648 0 0 0 27.6224-27.61728v-449.2288c0-23.33696 18.97984-42.32192 42.3168-42.32192s42.32192 18.98496 42.32192 42.3168v449.2288c0 61.9008-50.3552 112.26112-112.25088 112.26112H199.0656z"
      p-id="30809"
      fill={color}
    ></path>
  </svg>
);

export default CheckBox;
